import { useProgress } from "@react-three/drei";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bg from '../../images/w3oDayBg.svg';
import bg2 from '../../images/w3oNightBg.svg';
import name from '../../images/wxWhiteUpscaled.png';
//import logo from '../../images/w3oWhiteVert.svg';
import './Preloader.scss';
import {
  //FilledCircle,
  Container,
  Content,
  Curtain,
  Panel,
  PreloadLogoCont,
  PreloaderContainer,
  PreloaderWrapper,
  Progress,
  ProgressBarContainer,
  ProgressBarSection,
  SplitImage,
  SplitImage2,
  SplitImageContainer,
  Wrapper
} from './PreloaderElements';


//THREE FIBER ELEMENTS

import {
  Center,
  Environment,
  Instance, Instances,
  Lightformer,
  useGLTF
} from '@react-three/drei';
import { useFrame, useThree } from '@react-three/fiber';
import { easing } from 'maath';
import { useRef } from 'react';
import * as THREE from 'three';
const innerMaterial = new THREE.MeshStandardMaterial({
  transparent: true,
  opacity: 1,
  color: 'black',
  roughness: 0,
  side: THREE.FrontSide,
  blending: THREE.AdditiveBlending,
  polygonOffset: true,
  polygonOffsetFactor: 1,
  envMapIntensity: 2
})


/*
Kit-bash auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.3 scene.glb --transform
Licenses: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Authors:
  matousekfoto (https://sketchfab.com/matousekfoto) (Fruit Cake Slice)
    https://sketchfab.com/3d-models/fruit-cake-slice-7b9a33386eab4dd986aa0980054ead3c
  Felix Yadomi (https://sketchfab.com/felixyadomi) (Cute milkshake)
    https://sketchfab.com/3d-models/cute-milkshake-3ba52a41b4b248df953684861d9e7a20
  Second Studio (https://sketchfab.com/kayaaku) (Dry flower)
    https://sketchfab.com/3d-models/dry-flower-ff0005d6eb4d4077bd08b8992299c45c
  CDcruz (https://sketchfab.com/cdcruz) (Ikea - Pokal Glass Cups)
    https://sketchfab.com/3d-models/ikea-pokal-glass-cups-21837e54a14346aa900e1ae719779b86
*/
function Scene(props) {
  const { nodes, materials } = useGLTF('/w3oNameWhite.glb')
  const { size } = useThree();
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const width = size.width;
      let newScale = 1;

      if (width <= 600) {
        newScale = 0.5; // Adjust the scale value as needed for smaller screens
      } else if (width > 600 && width <= 1200) {
        newScale = 0.71428571; // Adjust the scale value as needed for medium-sized screens
      }

      setScale(newScale);
    };

    updateScale();

    window.addEventListener('resize', updateScale);

    return () => {
      window.removeEventListener('resize', updateScale);
    };
  }, [size?.width]);
  return (
    <group {...props} dispose={null} scale={scale}>
  <Center rotation={[0, 0, 0]} position={[0, 0, 0]} top>
  <group scale={.7}>
      <mesh 
        geometry={nodes.w3oName.geometry}
        material={materials['SVGMat.011']}
        position={[0, -3.5, 0]}
        rotation={[1.58, 0, -0.75]}
        scale={[3.7, 3.67, 3.08]}
      >

      
        </mesh>
        </group>
        </Center>
    </group>
  )
}

function Env({ perfSucks }) {
  const ref = useRef()
  useFrame((state, delta) => {
    // Animate the environment as well as the camera
    if (!perfSucks) {
      easing.damp3(ref.current.rotation, [Math.PI / 2, 0, state.clock.elapsedTime / 5 + state.pointer.x], 0.2, delta)
      easing.damp3(state.camera.position, [Math.sin(state.pointer.x / 4) * 9, 1.25 + state.pointer.y, Math.cos(state.pointer.x / 4) * 9], 0.5, delta)
      state.camera.lookAt(0, 0, 0)
    }
  })
  // Runtime environments can be too slow on some systems, better safe than sorry with PerfMon
   //<Environment frames={perfSucks ? 1 : Infinity} preset="city" resolution={256} background blur={0.8}> 
  
  return (
    
     <Environment >
      <Lightformer intensity={4} rotation-x={Math.PI / 2} position={[0, 5, -9]} scale={[10, 10, 1]} />
      <Lightformer intensity={4} rotation-x={Math.PI / 2} position={[0, 5, -9]} scale={[10, 10, 1]} />
      <group rotation={[Math.PI / 2, 1, 0]}>
        {[2, -2, 2, -4, 2, -5, 2, -9].map((x, i) => (
          <Lightformer key={i} intensity={1} rotation={[Math.PI / 4, 0, 0]} position={[x, 4, i * 4]} scale={[4, 1, 1]} />
        ))}
        <Lightformer intensity={0.5} rotation-y={Math.PI / 2} position={[-5, 1, -1]} scale={[50, 2, 1]} />
        <Lightformer intensity={0.5} rotation-y={Math.PI / 2} position={[-5, -1, -1]} scale={[50, 2, 1]} />
        <Lightformer intensity={0.5} rotation-y={-Math.PI / 2} position={[10, 1, 0]} scale={[50, 2, 1]} />
      </group>
      <group ref={ref}>
        <Lightformer intensity={5} form="ring" rotation-y={Math.PI / 2} position={[-5, 2, -1]} scale={[10, 10, 1]} />
      </group>
    </Environment>
  )
}




function Shoes({ data }) {
  const { nodes, materials } = useGLTF('./metal_hanger.glb')
  return (
    <Instances position={[-10,0,-30]}  scale={4.5} material={materials.Hanger} geometry={nodes.Metal_Hanger_Hanger_0.geometry}>
      <group position={[0, 0, 0]}>
        {data.map((props, i) => (
          <Shoe key={i} {...props} />
        ))}
      </group>
    </Instances>
  )
}

function Shoe({ random, color = new THREE.Color(), ...props }) {
  const ref = useRef()
  const [hovered, setHover] = useState(false)
  const gradientColors = ["black", "gray", "black", "gray", "black"];
  useFrame((state) => {
    const t = state.clock.getElapsedTime() + random * 10000
    ref.current.rotation.set(Math.cos(t / 4) / 2, Math.sin(t / 4) / 2, Math.cos(t / 1.5) / 2)
    ref.current.position.y = Math.sin(t / 1.5) / 2
   // ref.current.scale.x = ref.current.scale.y = ref.current.scale.z = THREE.MathUtils.lerp(ref.current.scale.z, hovered ? 1.4 : 1, 0.1)
   // ref.current.color.lerp(
   //   color.set(gradientColors[Math.floor(gradientColors.length * Math.random())]),
   //   hovered ? 1 : 0.1
  //  )
  })
  return (
    <group {...props}>
      <Instance  ref={ref} onPointerOver={(e) => (e.stopPropagation())}  />
    </group>
  )
}

export default function Preloader({isDarkMode, handleMusicToggle, started, onStarted, setIsModelLoaded, label = 'Progress Bar', width = 300 }) {
  const navigate = useNavigate();
  const onclick = () => {
    onStarted();
    //handleMusicToggle();
};
  const [completed, setCompleted] = useState(false);
  const [showPreloader, setShowPreloader] = useState(true);
  const strokeWidth = 6;
  const radius = (100 / 2.5) - (strokeWidth * 2);
  const circumference = radius * 2 * Math.PI;
  const [perfSucks, degrade] = useState(false)
  const { progress } = useProgress();
  const [position, setPosition] = useState([0, -1, 0]);
  const [isChecked, setIsChecked] = useState(true);
  const [animationCompleted, setAnimationCompleted] = useState(false);
  const [isTransitionComplete, setIsTransitionComplete] = useState(false);
  const customEase = [0.43, 0.13, 0.23, 0.96];
  const panelRef = useRef(null);
  const animationDuration = 2; // Set the animation duration to 2 seconds
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const handleTransitionEnd = (event) => {
    // Check if the transition property is 'transform'
    if (event.propertyName === 'transform') {
      setIsTransitionComplete(true);
      setAnimationCompleted(true);
  
      // Add a check for the Panel2 element
      if (event.target === panelRef.current) {
        onStarted(); // Call your onStarted function here
      }
    }
  };
  
  useEffect(() => {
    // Check if the animation has completed when the checkbox is checked
    if (isChecked && animationCompleted) {
      setTimeout(() => {
       // onStarted(); // Call onStarted after 3 seconds
      }, 0); // Delay for 3 seconds
    }
  }, [isChecked, animationCompleted]);
  
  useEffect(() => {
    if (progress === 100) {
      //setAnimationCompleted(true);
      
      // Delay the execution of actions for a minimum of 3 seconds
      setTimeout(() => {
        // Toggle the checkbox to play the animation of the panels
        setIsChecked(false);
  
        //
     
        // Perform the actions you want when progress is 100%
        setIsModelLoaded(true);
        navigate('/');
        setAnimationCompleted(true);
      }, 0); // 3000 milliseconds (3 seconds) delay
    }
  }, [progress, setIsModelLoaded, navigate, setIsChecked]);


  
  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      if (width <= 600) {
        setPosition([0, 0, 0]); // Adjust the position value as needed for smaller screens
      } else {
        setPosition([0, 0, 0]); // Default position value for larger screens
      }
    }
    

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (

    <PreloaderContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={`${started ? 'hidden' : ''}`}
      showPreloader={showPreloader ? 1 : 0}

    >
      <Curtain>
        <Wrapper>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => {
              setIsChecked(!isChecked);
              
            }}
          />


<Panel
  ref={panelRef} 
      style={{
        willChange: 'transform',
        backgroundImage: `url(${isDarkMode ? bg : bg2})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        transform: isChecked ? 'translateX(0)' : 'translateX(-100%)',
      }}
      className={`curtain__panel--left ${
        isChecked ? 'curtain__panel--left--checked' : ''
      }`}
  
    
      onTransitionEnd={handleTransitionEnd}
    >
    <PreloadLogoCont   >

{/*Left To Right X variation
<SplitImageContainer         

      initial={{ x: '-100%', scale: 0.8, opacity: 0 }}
      animate={{ x: 0, scale: 1, opacity: 1 }}
      transition={{
        delay: 1,
        type: 'spring',
        damping: 8,
        stiffness: 80,
        duration: 1.25,
      }}
      style={{
        backgroundImage: `url(${isDarkMode ? name : name})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >

*/}

<>
      {isSafari ? (
        // Render this component for Safari
        <SplitImageContainer
         initial={{
            // y: '-150vh', 
            // scale: 0.8, 
             opacity: 0, 
             filter: 'blur(10px)' }}
          animate={{ 
            y: 0, 
          scale: 1, 
          opacity: 1, 
          filter: 'blur(0px)' }}
          transition={{
            delay: .25,
            type: 'spring',
            damping: 15,
            stiffness: 200,
            duration: 0.5,
          }}
          style={{
            willChange: 'transform',
            backgroundImage: `url(${isDarkMode ? name : name})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <PreloadLogoCont>
            <SplitImage />
            <SplitImage2 />
          </PreloadLogoCont>
        </SplitImageContainer>
      ) : (
        // Render this component for non-Safari browsers
        <SplitImageContainer
          initial={{
            // y: '-150vh', 
            // scale: 0.8, 
             opacity: 0, 
             filter: 'blur(10px)' }}
          animate={{ 
            y: 0, 
          scale: 1, 
          opacity: 1, 
          filter: 'blur(0px)' }}
          transition={{
            delay: 0.25,
            type: 'spring',
            damping: 15,
            stiffness: 200,
            duration: 0.75,
          }}
          style={{
            backgroundImage: `url(${isDarkMode ? name : name})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <PreloadLogoCont>
            <SplitImage />
            <SplitImage2 />
          </PreloadLogoCont>
        </SplitImageContainer>
      )}
    </>

    </PreloadLogoCont>
  {/*

<SplitImageContainer         

      initial={{ y: '-100vh', scale: 0.8, opacity: 1}}
      animate={{ y: '0', scale: 1, opacity: 1}}
      transition={{
        delay: 1.5,
        type: 'spring',
        damping: 15,
        stiffness: 200,
        duration: 1.25,
      }}
      style={{
        willChange: 'transform',
        backgroundImage: `url(${isDarkMode ? name : name})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
             <PreloadLogoCont>
      <SplitImage    />
      <SplitImage2    
      />
      </PreloadLogoCont>
    </SplitImageContainer>





             <LogoName        style={{
marginLeft: '(50%)',
transformOrigin: 'right center',
}}
             transition={  { delay: 0.1}}
                             initial ={ { scale: 0, opacity: 0, rotateX: -360, y:10000  }} // Start with flip
                            animate = {{ scale: 1.02, opacity: 1, rotateX: 0, y:0 }} // End with no flip
                            final = {{ scale: 1, opacity: 1, rotateX: 0 }}  className="logoName">
          <PreloadLogoCont>
            <PreloadLogo style={{


transformOrigin: `right` ,
}} src={left} />
          </PreloadLogoCont>
        </LogoName>
  */}
      {/* Content for the left panel */}
    </Panel>


{/*
             <LogoName2          style={{


transformOrigin: ' center',
}}
             transition={  { delay: 1.5}}
                            initial ={ { scale: 0, opacity: 0, rotateX: 180, y: -100 }} // Start with flip
                            animate = {{ scale: 1.02, opacity: 1, rotateX: 0, y: 0}} // End with no flip
                            final = {{ scale: 1, opacity: 1, rotateX: 0 }} 
                            className="logoName">
          <PreloadLogoCont  >
            <PreloadLogo style={{


transformOrigin: `left` ,
}} src={right}  />
          </PreloadLogoCont>
        </LogoName2>
*/}
      {/* Content for the right panel */}

        </Wrapper>

        <Content className="curtain__content">
      <PreloaderWrapper >



        <Container  className={`${!isChecked ? "hidden" : ""}`}>
          <ProgressBarSection>
            <ProgressBarContainer>

              <Progress>{Math.round(progress)}%</Progress>
            </ProgressBarContainer>
          </ProgressBarSection>
        </Container> 
     





        
{/*

//enter button
        <EnterButtonWrap>
        <EnterButton
          //className="loadingScreen__button"
          disabled={progress < 100}
          onClick={onclick}
        >
          ENTER
        </EnterButton>
        </EnterButtonWrap>





      // 3D w3o button
      <Suspense >
    <Canvas camera={{ position: [0, 0, 10], fov: 30 }} performance={{ min: 0.1 }}>
      <ambientLight intensity={0.5} />
      <directionalLight intensity={0.3} position={[5, 25, 20]} />
    
      <Shoes data={data}  />

      <PerformanceMonitor onDecline={() => degrade(true)} />
    
      <group position={position} rotation={[0, -0.75, 0]}>
        <Scene />
        <Env perfSucks={perfSucks} />
      </group>
    
    </Canvas>
  </Suspense>
      


        */}
        
      </PreloaderWrapper>
      </Content>
    </Curtain>
    </PreloaderContainer>
    
  );
}
